import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';

import { extractValueFromStore } from '@ninety/platform/services/state-util';
import { selectCompany } from '@ninety/platform/state/app-global/company/company-state.selectors';

@Injectable({ providedIn: 'root' })
export class MasteryGuard {
  constructor(
    private readonly store: Store,
    private readonly router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    const company = extractValueFromStore(this.store, selectCompany);
    return company?.settings?.mastery?.enabled ? true : this.router.parseUrl('/home');
  }
}
